<template>
  <div class="index">
    <transition name="fade">
      <div class="searchBar" v-show="searchFlag">
        <el-input
          v-model="keyName"
          clearable
          placeholder="请输入职位关键字"
          @keyup.enter.native="search"
        />
      </div>
    </transition>
    <!-- <div class="searchBar" v-show="searchFlag">
      <el-input v-model="keyName" clearable placeholder="请输入职位关键字" />
    </div> -->
    <el-drawer
      title=""
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose">
      <el-row>
        <span @click="go('/index')">首页</span>
      </el-row>
      <el-row>
        <span @click="go('/recruitList')">校园招聘</span>
      </el-row>
    </el-drawer>
    <div class="menu">
      <img src="@/assets/image/logo.png" alt="" />
      <i class="el-icon-menu"  @click="showMenu"></i>
    </div>
    <div class="searchBoxPhone">
        <el-input
          v-model="keyName"
          clearable
          placeholder="请输入职位关键字"
          @keyup.enter.native="search"
        />
      </div>
    <div class="header">
      <el-row>
        <el-col class="item" :lg="2" :md="2" :xs="8" @click="goto('/index')">
          <img src="@/assets/image/logo.png" alt="" />
        </el-col>
        <el-col class="item" :lg="2" :md="2" :xs="8" :offset="16" @click="goto('/index')">
          <span>首页</span>
        </el-col>
        <el-col class="item" :lg="2" :md="2" :xs="5">
          <span @click="goto('recruitList')">校招招聘</span>
        </el-col>
      </el-row>
    </div>
    <div class="banner">
      <div class="searchBox">
        <el-input
          v-model="keyName"
          clearable
          placeholder="请输入职位关键字"
          @keyup.enter.native="search"
        />
      </div>
      <div class="line"></div>
      <div class="slideDown" @click="enter">
        <i class="sd-Icon-container el-icon-d-arrow-right"></i>
      </div>
    </div>
    <div class="positionTitle">校园招聘</div>
    <div class="position" id="position">
      <div class="inner">
        <el-row :gutter="20">
          <el-col class="item" :lg="6" :md="6" :xs="24" v-for="(item, index) in jobTypeList" :key="index">
            <div @click="goto('recruitList',item.jobType)">
              <p>{{item.jobType}}</p>
              <p>共{{item.cnt}}个职位<i class="el-icon-arrow-right"></i></p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="footer">
      <div class="container">
        <el-row>
          <el-col :span="6">
            <img src="@/assets/image/logo.png" alt="">
          </el-col>
          <el-col :span="18">
            <img src="@/assets/image/publicSecurityIcon.png" alt="">
            <span> <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32058302002921">公安部备案号：32058302002921</a> | 网站备案号：苏ICP备2021026395号-1 昆山丘钛微电子科技股份有限公司</span>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="welcome" v-show="welcomeFlag">
      <div class="title">欢迎</div>
      <div><img src="@/assets/image/welcome.png" alt="" /> <span>同学：</span> </div>
      <p style="text-indent: 1.5em;">
        感谢您关注丘钛微！我们秉持“人人成长、人人成就”的人才培育理念，期待能和潜力无限的你，一起开拓丘钛事业，共攀科技巅峰!
      </p>
      <span @click="cancelWelcome"><i class="el-icon-circle-close"></i></span>
      <div class="cancel"></div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  name: "index",
  data() {
    return {
      keyName: "",
      scrollHeight: "",
      searchFlag: false,
      welcomeFlag: true,
      drawer: false,
      direction: 'rtl',
      jobTypeList:[]
    };
  },
  watch: {
    scrollHeight() {
      if (this.scrollHeight > 300) {
        this.searchFlag = true;
      } else {
        this.searchFlag = false;
      }
    },
  },
  created(){
    if(!this.$session.get("time")){
      this.$session.set("time",moment().format('X'))
      this.welcomeFlag = true;
    }else{
      let nowTime = this.$session.get("time");
      if(moment().format('X') - nowTime < 3600){
        console.log(moment().format('X') - nowTime)
        this.welcomeFlag = false;
      }else{
        this.$session.set("time",moment().format('X'))
        this.welcomeFlag = true;
      }
    }
  },
  mounted() {
    this.getList();
    // let _this = this;
    // setTimeout(function(){
    //   _this.welcomeFlag = false;
    // },2000)
    // this.scrollTop = `${document.scrollTop}`;
    // let that = this;
    // window.onresize = function(){
    //   that.scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
    //   if(that.$refs.page){
    //     that.$refs.page.style.minHeight = clientHeight - 100 + 'px';
    //   }
    // }
    window.addEventListener("scroll", this.scrollHandle); //绑定页面滚动事件
  },
  methods: {
    handleClose(){
      this.drawer = false;
    },
    showMenu(){
      this.drawer = !this.drawer;
    },
    cancelWelcome(){
      this.welcomeFlag = false;
    },
    search() {
      this.$router.push({
        name: "recruitList",
        params: {
          jobName: this.keyName,
        },
      });
    },
    goto(address,type) {
      this.$router.push({
        name: address,
        params:{
          type: type
        }
      });
    },
    go(address){
      this.$router.push(address);
    },
    scrollHandle(e) {
      this.scrollHeight = e.srcElement.scrollingElement.scrollTop; // 获取页面滚动高度
    },
    enter() {
      let target = document.querySelector(".line");
      target && target.scrollIntoView(500);
    },
    FixTop(obj) {
      var obj = document.getElementById(obj);
      var objOffset = obj.offsetTop;
      //console.log("对象高度"+ objOffset);
      window.onscroll = function () {
        var bodyScrollOffset = document.body.scrollTop;
        //console.log('往下滚动距离高度'+ bodyScrollOffset);
        var Result = objOffset - bodyScrollOffset;
        //console.log("对象减去滚动高度"+ Result);
        if (Result < 0 && bodyScrollOffset > objOffset) {
          obj.style.position = "fixed";
          obj.style.top = 0;
          obj.setAttribute("class", "fixtop");
        } else {
          obj.style.position = "static";
          obj.setAttribute("class", "fixnone");
        }
      };
    },
    getList(){
      let params = {
        current:1,
        pageSize:1000
      };
      this.axios({
        url: "/apis/jobType/list",
        method: "get",
        params: params,
      }).then((res) => {
        if (res.code == 200) {
          this.jobTypeList = res.rows;
        } else {
          this.jobTypeList = [];
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.index {
  height: 100%;
  background-color: #000;
}
.menu{
  height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,.3);
  width: 100%;
  z-index: 100;
  display: none;
  @media (max-width: 1200px) {
    display: block;
  }
  >img{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 15px;
    height: 50%;
  }
  >i{
    font-size: 30px;
    color: #fff;
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
  }
}
.searchBoxPhone{
  background-color: rgba(0,0,0,.3);
  padding: 10px 15px;
  position: fixed;
  top: 60px;
  width: 100%;
  z-index: 100;
  display: none;
  @media (max-width: 1200px) {
    display: block;
  }
}
.searchBar {
  padding: 0 120px;
  width: 100%;
  height: 130px;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #000;
  z-index: 100;
  padding-top: 70px;
  box-sizing: border-box;
  @media (max-width: 1200px) {
    display: none;
  }
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  min-width: 960px;
  width: 100%;
  padding: 0 120px;
  line-height: 45px;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.2);
  @media (max-width: 1200px) {
    display: none;
    min-width: 100%;
    padding: 0 0 0 15px;
    background-color: rgba(0, 0, 0, 0.2);
  }
  .item {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 60px;
    color: #fff;
    font-size: 14px;
    @media (max-width: 1200px) {
      padding: 5px 0;
      font-size: 16px;
    }
    span {
      display: inline-block;
      line-height: 30px;
      &.active {
        border-bottom: 2px solid #fff;
      }
    }
    &:nth-child(1) {
      @media (max-width: 1200px) {
        margin-right: 0;
      }
      img {
        width: 100%;
      }
    }
  }
}
.banner {
  width: 100%;
  background-image: url(../assets/image/banner.jpg);
  background-position: center center;
  background-color: #464646;
  background-size: 100% 100%;
  height: 100%;
  position: relative;
  @media (max-width: 1200px) {
    height: 200px;
  }
  .line {
    height: 1px;
    background-color: transparent;
    position: absolute;
    left: 0;
    bottom: 130px;
  }
  .searchBox {
    position: absolute;
    width: 420px;
    height: 48px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    @media (max-width: 1200px) {
      display: none;
    }
  }
  .slideDown {
    width: 40px;
    height: 40px;
    position: absolute;
    bottom: 20px;
    left: 50%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    cursor: pointer;
    -webkit-transform: translateX(-50%) rotate(90deg);
    -moz-transform: translateX(-50%) rotate(90deg);
    -ms-transform: translateX(-50%) rotate(90deg);
    -o-transform: translateX(-50%) rotate(90deg);
    transform: translateX(-50%) rotate(90deg);
    @media (max-width: 1200px) {
      display: none;
    }
    .sd-Icon-container {
      font-size: 40px;
      font-weight: bold;
      top: 0;
      color: #df7b0d;
      -webkit-animation: jump 1s infinite;
      -moz-animation: jump 1s infinite;
      -o-animation: jump 1s infinite;
      animation: jump 1s infinite;
    }
  }
}
@keyframes jump {
  0% {
    -webkit-transform: translateX(0);
    -moz-transform: translateX(0);
    -o-transform: translateX(0);
    transform: translateX(0);
  }
  50% {
    -webkit-transform: translateX(-10%);
    -moz-transform: translateX(-10%);
    -o-transform: translateX(-10%);
    transform: translateX(-10%);
  }
  100% {
    -webkit-transform: translateX();
    -moz-transform: translateX();
    -o-transform: translateX();
    transform: translateX();
  }
}
.positionTitle {
  font-weight: normal;
  font-size: 40px;
  color: rgb(255, 255, 255);
  text-align: center;
  margin: 0;
  padding: 40px 24px;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  background-color: rgb(0, 0, 0);
  @media (max-width: 1200px) {
    font-size: 30px;
    padding: 20px 0;
  }
}
.position {
  background-color: #000;
  padding-bottom: 100px;
  z-index: 1000000;
  @media (max-width: 1200px) {
    padding-bottom: 30px;
  }
  .inner {
    width: -webkit-calc(100% - 8.33333% * 2);
    width: -moz-calc(100% - 8.33333% * 2);
    width: calc(100% - 8.33333% * 2);
    margin: 0 auto;
    background-color: #000;
    .item {
      color: #fff;
      margin-bottom: 20px;
      cursor: pointer;
      div {
        background-color: #333333;
        padding: 20px 50px 30px;
        @media (max-width: 1200px) {
          padding: 15px;
        }
        p {
          text-align: left;
          @media (max-width: 1200px) {
            margin: 5px 0;
          }
          &:first-child {
            font-size: 20px;
            font-weight: 500;
            line-height: 28px;
            @media (max-width: 1200px) {
              font-size: 16px;
            }
          }
          &:last-child {
            font-size: 14px;
            color: #989cb2;
            font-weight: 400;
            @media (max-width: 1200px) {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}

.footer{
  height: 100px;
  background-color: #000;
  border-top: 1px solid rgba(153, 153, 153,.5);
  @media (max-width: 1200px) {
    height: 80px;
  }
  .container{
    height: 100%;
    width: 1200px;
    margin: 0 auto;
    @media (max-width: 1200px) {
      width: 100%;
    }
    .el-row{
      height: 100%;
      >div{
        height: 100%;
        display: flex;
        align-items: center;
        &:first-of-type{
          justify-content: flex-start;
          @media (max-width: 1200px) {
            display: none;
          }
        }
        &:last-of-type{
          font-size: 13px;
          color: #fff;
          justify-content: flex-end;
          @media (max-width: 1200px) {
            width: 100%;
            padding: 0 15px;
            font-size: 12px;
            img{
              margin-right: 5px;
            }
          }
          img{
            margin-right: 10px;
          }
        }
      }
    }
  }
}

.welcome{
  text-align: left;
  width: 500px;
  padding: 0 50px 40px;
  border-radius: 10px;
  position: fixed;
  background-color: #fff;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  overflow: hidden;
  line-height: 1.5;
  @media (max-width: 1200px) {
    width: 90%;
    padding: 0 20px 20px;
    font-size: 14px;
  }
  >div{
    &:nth-child(2){
      padding-top: 20px;
      img,span{
        vertical-align: middle;
      }
    }
  }
  .title{
    padding-top: 130rpx;
		flex-direction: column;
		align-items: center;
    justify-content: center;
		width: 130%;
		height: 80px;
    line-height: 80px;
    font-size: 26px;
		background: #686868;
		position: relative;
		left: -15%;
		border-bottom-left-radius: 45%;
		border-bottom-right-radius: 45%;
		overflow: hidden;
		text-align: center;
		cursor: pointer;
    color: #fff;
    @media (max-width: 1200px) {
      height: 60px;
      line-height: 60px;
      font-size: 22px;
    }
  }
  p{
    span{
      color: #0a97e6;
      font-weight: bold;
    }
  }
  >span{
    position: absolute;
    right: 10px;
    top: 6px;
    color: #fff;
    font-size: 28px;
    cursor: pointer;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
<style lang="scss">
.index {
  .el-input__inner {
    border-radius: 100px;
    height: 48px;
    line-height: 48px;
    font-size: 15px;
    background-color: rgba(255,255,255, .9);
  }
  .searchBoxPhone{
    display: none;
    .el-input__inner {
      border-radius: 100px;
      height: 37px;
      line-height: 37px;
      font-size: 15px;
    }
  }
}
.el-drawer__wrapper{
  .el-drawer{
    background-color: #000;
    .el-drawer__header{
      padding: 20px 15px 0 20px;
    }
    .el-dialog__close{
      color: #fff;
    }
    .el-drawer__body{
      line-height: 2;
      span{
        display: inline-block;
        width: 100%;
        text-align: right;
        padding-right: 15px;
        color: #fff;
        font-weight: bold;
        margin-bottom: 10px;
      }
    }
  }
  
}

</style>



// WEBPACK FOOTER //
// src/components/index.vue